import React, { useState } from 'react';
import { Container, Row, Col, Card, DropdownButton, Dropdown, ButtonGroup, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import IndividualService from '../../../../services/Public/Application/application.service'
import { Table } from 'rsuite';
import { codeApplicationType } from '../../../../fakeCodeTable';
import { useDispatch } from 'react-redux';
import LoadingSpinner from '../../../Shared/GenericComponents/LoadingSpinner';
import Swal from 'sweetalert2';
import Information from '../../../Shared/Card/Information';
import { GetAppInstruction } from '../../../Shared/InformationContent/GeneralInformation';
import ReviewPdf from '../../../Shared/Card/ReviewPdf';

function Applications() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [showDropDown, setShowDropDown] = useState(true);
    const [applications, setApplications] = useState([]);

    const [hasLoadedHistorical, setHasLoadedHistorical] = useState(false);
    const [historicalRecords, setHistoricalRecords] = useState([]);

    const [currentAppTypeIds, setCurrentAppTypeIds] = useState([]);
    const [hasLsiCred, setHasLsiCred] = useState(false);
    const [currentCredentialTypes, setCurrentCredentialTypes] = useState([]);
    const push = useNavigate();
    const dispatch = useDispatch();
    const createApplication = (id) => {
        IndividualService.createApplication(id).then((response) => {
            if (response.status == 200) {
                IndividualService.getIndividualApplication(response.data).then((response) => {
                    navigateAndSetCurrentApp(response.data)
                })
            }
            else {
                //give an alert of the fail
            }
        })

    }
    let applicationDropDown =
        <DropdownButton as={ButtonGroup} variant='primary' title="Start a New Application">
            {
                codeApplicationType.map((item, i) => {
                    if (!currentAppTypeIds.includes(item.abbreviation) &&
                        !currentCredentialTypes.includes(item.abbreviation) &&
                        (item.id != "6" || (item.id == "6" && hasLsiCred)) &&
                        (item.id != "7" && item.id != "8"))
                        return (<Dropdown.Item value={item.id} key={item.id} onClick={x => createApplication(item.id)}> {item.applicationType} ({item.abbreviation})</Dropdown.Item>)
                })
            }
        </DropdownButton>;

    useEffect(() => {
        refreshApplicationGrid();
        IndividualService.getHistoricalApplications().then((response) => {
            if (response.data?.apps.length) {

                var sortedApps = response.data.apps.sort((a, b) => {
                    return new Date(b.dateSubmitted) - new Date(a.dateSubmitted)
                });
                setHistoricalRecords({ creds: response.data.creds, apps: sortedApps });
            }
            setHasLoadedHistorical(true)
        });
    }, [])
    const refreshApplicationGrid = () => {
        setHasLoaded(false);
        IndividualService.getPendingApplications().then((response) => {
            setApplications(response.data?.apps)
            var test = response.data?.creds?.forEach(val => {
                if (val.credentialType.id == 4 && (val.status.status == 'Active' || val.status.status == 'Expired')) {
                    setHasLsiCred(true);
                }
            })
            setCurrentAppTypeIds(response.data?.apps.map(x => x.applicationType?.abbreviation)); // Will need to get user certifications later to be part of this to filter out
            setCurrentCredentialTypes(response.data?.creds?.map(x => x.credentialType?.prefix)); // Will need to get user certifications later to be part of this to filter out
            let allowedAppTypes = ["EI", "LSI", "PE", "PLS"];
            if (response.data?.apps)
            {
                var appTypes = response.data.apps.map(x => x.applicationType.abbreviation);
                allowedAppTypes = allowedAppTypes.filter(type => !appTypes.includes(type));
            }
            if (response.data?.creds)
            {
                var credTypes = response.data.creds.map(x => x.credentialType.prefix);
                allowedAppTypes = allowedAppTypes.filter(type => !credTypes.includes(type));
            }
            if (allowedAppTypes.length == 0) //ind currently has 4 app types, if this increases we need to increase this number
                setShowDropDown(false);
            else
                setShowDropDown(true);
            setHasLoaded(true);
        })
    }

    const deleteDraft = (rowData) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                IndividualService.deleteDraft(rowData.id).then((response) => {
                    refreshApplicationGrid();
                })
            }
        })
    }
    const navigateAndSetCurrentApp = (rowData) => {
        dispatch({ type: "PERSIST_CURRENT_APP_ID", payload: rowData.id });
        dispatch({ type: "PERSIST_CURRENT_APP_TYPE_ID", payload: rowData.applicationType.id });
        if (rowData?.sections?.length) {
            var route = [];
            var baseLink = "/individual";
            switch (rowData?.applicationType?.id) {
                case 1:
                    baseLink += "/eiapp/";
                    break;
                case 2:
                    baseLink += "/lsiapp/";
                    break;
                case 3:
                case 4:
                    baseLink += "/peapp/";
                    break;
                case 5:
                case 6:
                    baseLink += "/plsapp/";
                    break;
            }
            for (var i = 0; i < rowData.sections.length; i++) {
                var link = baseLink;
                let sectionId = rowData.sections[i].sectionType.id
                switch (sectionId) {
                    case 1:
                        link += "contactInformation"
                        break;
                    case 2:
                        link += "educationRecord"
                        break;
                    case 3:
                        link += "personalReferences"
                        break;
                    case 4:
                        link += "violations"
                        break;
                    case 5:
                        link += "employment"
                        break;
                    case 6:
                        link += "quizzes"
                        break;
                    case 7:
                        link += "experience"
                        break;
                    case 8:
                        link += "acknowledgement"
                        break;
                    case 9:
                        link += "review"
                        break;
                    case 11:
                        link += "examination"
                        break;
                    case 12:
                        link += "recommendation"
                        break;
                    case 16:
                        link += "coopexperience"
                        break;
                    case 17:
                        link += "residency"
                        break;
                    default:
                        break;
                }
                route.push({ sectionId: rowData.sections[i].sectionType.id, route: link })
            }

        }

        dispatch({ type: "PERSIST_CURRENT_ROUTE", payload: route })
        var sectionsLink = baseLink + "sections";
        push(sectionsLink);
    }

    return (
        <div className="applicationsPage">

            <Container fluid>
                <h4 className="mb-3">Applications</h4>
                <Row>
                    <Col><Information content={GetAppInstruction()} /></Col>
                </Row>
                <br />
                <Row className="mb-3">
                    <Col>
                        <Card>
                            <Card.Header>
                                <Row>
                                    {hasLoaded && showDropDown &&
                                        <Col>
                                            <div className="d-flex justify-content-end">
                                                {applicationDropDown}
                                            </div>
                                        </Col>}
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                {hasLoaded ?
                                    <Table wordWrap autoHeight data={applications}>
                                        <Table.Column width={200}>
                                            <Table.HeaderCell>
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (
                                                    <>
                                                        <Button onClick={() => navigateAndSetCurrentApp(rowData)}> {
                                                            rowData.status?.status === "Draft"
                                                                ? "Continue"
                                                                : rowData.sections?.filter(x => x.isUserEditable == true).length
                                                                    ? "Continue"
                                                                    : "View"}</Button>
                                                        {rowData.status?.status === "Draft" &&
                                                            <Button className="ms-1" variant="danger" onClick={() => deleteDraft(rowData)}>Delete</Button>
                                                        }
                                                    </>
                                                )}
                                            </Table.Cell>
                                        </Table.Column>

                                        <Table.Column flexGrow={2}>
                                            <Table.HeaderCell>
                                                Application Type
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (rowData.applicationType?.type)}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} minWidth={110}>
                                            <Table.HeaderCell>
                                                Date Created
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (rowData.dateCrte ? new Date(rowData.dateCrte).toLocaleDateString() : '')}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} minWidth={110}>
                                            <Table.HeaderCell>
                                                Date Submitted
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (rowData.dateSubmitted ? new Date(rowData.dateSubmitted).toLocaleDateString() : '')}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} minWidth={110}>
                                            <Table.HeaderCell>
                                                Review Status
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (rowData.status?.status)}
                                            </Table.Cell>
                                        </Table.Column>

                                    </Table> : <LoadingSpinner />
                                }

                            </Card.Body>
                        </Card></Col>
                </Row>
                <Row >
                    <Col>
                        <Card>
                            <Card.Header><h6>Historical Applications</h6></Card.Header>
                            <Card.Body>
                                {hasLoadedHistorical ?
                                    <Table wordWrap autoHeight data={historicalRecords.apps} headerHeight={60}>
                                        <Table.Column flexGrow={1} minWidth={200}>
                                            <Table.HeaderCell></Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => <ReviewPdf id={rowData.id} parentTypeId={1} />}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} minWidth={275}>
                                            <Table.HeaderCell>
                                                Application Type
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (rowData.applicationType?.type)}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} minWidth={110}>
                                            <Table.HeaderCell>
                                                License Status
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => {
                                                    var cred = historicalRecords.creds.filter(x => x.applicationId == rowData.id);
                                                    if (cred[0].credential)
                                                        return (cred[0].credential.status?.status)
                                                }}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} minWidth={110}>
                                            <Table.HeaderCell>
                                                Expiration Date
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => {
                                                    var cred = historicalRecords.creds.filter(x => x.applicationId == rowData.id);
                                                    if (cred[0].credential)
                                                        return (cred[0].credential.expirationDate ? new Date(cred[0].credential.expirationDate).toLocaleDateString() : '')
                                                }}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} minWidth={110}>
                                            <Table.HeaderCell>
                                                Date Created
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (rowData.dateCrte ? new Date(rowData.dateCrte).toLocaleDateString() : '')}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} minWidth={110}>
                                            <Table.HeaderCell>
                                                Date Submitted
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (rowData.dateSubmitted ? new Date(rowData.dateSubmitted).toLocaleDateString() : '')}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} minWidth={110}>
                                            <Table.HeaderCell>
                                                Date Approved/Declined
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => {
                                                    var cred = historicalRecords.creds.filter(x => x.applicationId == rowData.id);
                                                    if (cred.length)
                                                        return (cred[0].dateActioned ? new Date(cred[0].dateActioned).toLocaleDateString() : '')
                                                }}
                                            </Table.Cell>
                                        </Table.Column>
                                        <Table.Column flexGrow={1} minWidth={110}>
                                            <Table.HeaderCell>
                                                Review Status
                                            </Table.HeaderCell>
                                            <Table.Cell>
                                                {rowData => (rowData.status?.status)}
                                            </Table.Cell>
                                        </Table.Column>

                                    </Table> : <LoadingSpinner />
                                }
                            </Card.Body>
                        </Card></Col>
                </Row>
            </Container>
        </div>
    )
}
export default Applications;